// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _postV1InventoryItems = async (url: string, request: Types.PostV1InventoryItemsRequest): Promise<Types.PostV1InventoryItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryItems: Api['postV1InventoryItems'] = async (request: Types.PostV1InventoryItemsRequest): Promise<Types.PostV1InventoryItemsResponses> => {
  return await _postV1InventoryItems(baseUrl, request)
}
const _getV1InventoryItems = async (url: string, request: Types.GetV1InventoryItemsRequest): Promise<Types.GetV1InventoryItemsResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryItems: Api['getV1InventoryItems'] = async (request: Types.GetV1InventoryItemsRequest): Promise<Types.GetV1InventoryItemsResponses> => {
  return await _getV1InventoryItems(baseUrl, request)
}
const _getV1InventoryItemsId = async (url: string, request: Types.GetV1InventoryItemsIdRequest): Promise<Types.GetV1InventoryItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryItemsId: Api['getV1InventoryItemsId'] = async (request: Types.GetV1InventoryItemsIdRequest): Promise<Types.GetV1InventoryItemsIdResponses> => {
  return await _getV1InventoryItemsId(baseUrl, request)
}
const _putV1InventoryItemsId = async (url: string, request: Types.PutV1InventoryItemsIdRequest): Promise<Types.PutV1InventoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InventoryItemsId: Api['putV1InventoryItemsId'] = async (request: Types.PutV1InventoryItemsIdRequest): Promise<Types.PutV1InventoryItemsIdResponses> => {
  return await _putV1InventoryItemsId(baseUrl, request)
}
const _deleteV1InventoryItemsId = async (url: string, request: Types.DeleteV1InventoryItemsIdRequest): Promise<Types.DeleteV1InventoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1InventoryItemsId: Api['deleteV1InventoryItemsId'] = async (request: Types.DeleteV1InventoryItemsIdRequest): Promise<Types.DeleteV1InventoryItemsIdResponses> => {
  return await _deleteV1InventoryItemsId(baseUrl, request)
}
const _postV1InventoryItemsImport = async (url: string, request: Types.PostV1InventoryItemsImportRequest): Promise<Types.PostV1InventoryItemsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryItemsImport: Api['postV1InventoryItemsImport'] = async (request: Types.PostV1InventoryItemsImportRequest): Promise<Types.PostV1InventoryItemsImportResponses> => {
  return await _postV1InventoryItemsImport(baseUrl, request)
}
const _getV1InventoryItemsGenerateExcel = async (url: string, request: Types.GetV1InventoryItemsGenerateExcelRequest): Promise<Types.GetV1InventoryItemsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryItemsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryItemsGenerateExcel: Api['getV1InventoryItemsGenerateExcel'] = async (request: Types.GetV1InventoryItemsGenerateExcelRequest): Promise<Types.GetV1InventoryItemsGenerateExcelResponses> => {
  return await _getV1InventoryItemsGenerateExcel(baseUrl, request)
}
const _postV1InventoryItemsCheck = async (url: string, request: Types.PostV1InventoryItemsCheckRequest): Promise<Types.PostV1InventoryItemsCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-items/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryItemsCheck: Api['postV1InventoryItemsCheck'] = async (request: Types.PostV1InventoryItemsCheckRequest): Promise<Types.PostV1InventoryItemsCheckResponses> => {
  return await _postV1InventoryItemsCheck(baseUrl, request)
}
const _postV1NonInventoryItems = async (url: string, request: Types.PostV1NonInventoryItemsRequest): Promise<Types.PostV1NonInventoryItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/non-inventory-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1NonInventoryItems: Api['postV1NonInventoryItems'] = async (request: Types.PostV1NonInventoryItemsRequest): Promise<Types.PostV1NonInventoryItemsResponses> => {
  return await _postV1NonInventoryItems(baseUrl, request)
}
const _getV1NonInventoryItems = async (url: string, request: Types.GetV1NonInventoryItemsRequest): Promise<Types.GetV1NonInventoryItemsResponses> => {
  const queryParameters: (keyof Types.GetV1NonInventoryItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/non-inventory-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1NonInventoryItems: Api['getV1NonInventoryItems'] = async (request: Types.GetV1NonInventoryItemsRequest): Promise<Types.GetV1NonInventoryItemsResponses> => {
  return await _getV1NonInventoryItems(baseUrl, request)
}
const _getV1NonInventoryItemsId = async (url: string, request: Types.GetV1NonInventoryItemsIdRequest): Promise<Types.GetV1NonInventoryItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1NonInventoryItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/non-inventory-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1NonInventoryItemsId: Api['getV1NonInventoryItemsId'] = async (request: Types.GetV1NonInventoryItemsIdRequest): Promise<Types.GetV1NonInventoryItemsIdResponses> => {
  return await _getV1NonInventoryItemsId(baseUrl, request)
}
const _putV1NonInventoryItemsId = async (url: string, request: Types.PutV1NonInventoryItemsIdRequest): Promise<Types.PutV1NonInventoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/non-inventory-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1NonInventoryItemsId: Api['putV1NonInventoryItemsId'] = async (request: Types.PutV1NonInventoryItemsIdRequest): Promise<Types.PutV1NonInventoryItemsIdResponses> => {
  return await _putV1NonInventoryItemsId(baseUrl, request)
}
const _deleteV1NonInventoryItemsId = async (url: string, request: Types.DeleteV1NonInventoryItemsIdRequest): Promise<Types.DeleteV1NonInventoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/non-inventory-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1NonInventoryItemsId: Api['deleteV1NonInventoryItemsId'] = async (request: Types.DeleteV1NonInventoryItemsIdRequest): Promise<Types.DeleteV1NonInventoryItemsIdResponses> => {
  return await _deleteV1NonInventoryItemsId(baseUrl, request)
}
const _postV1AssemblyItems = async (url: string, request: Types.PostV1AssemblyItemsRequest): Promise<Types.PostV1AssemblyItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssemblyItems: Api['postV1AssemblyItems'] = async (request: Types.PostV1AssemblyItemsRequest): Promise<Types.PostV1AssemblyItemsResponses> => {
  return await _postV1AssemblyItems(baseUrl, request)
}
const _getV1AssemblyItems = async (url: string, request: Types.GetV1AssemblyItemsRequest): Promise<Types.GetV1AssemblyItemsResponses> => {
  const queryParameters: (keyof Types.GetV1AssemblyItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssemblyItems: Api['getV1AssemblyItems'] = async (request: Types.GetV1AssemblyItemsRequest): Promise<Types.GetV1AssemblyItemsResponses> => {
  return await _getV1AssemblyItems(baseUrl, request)
}
const _getV1AssemblyItemsId = async (url: string, request: Types.GetV1AssemblyItemsIdRequest): Promise<Types.GetV1AssemblyItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1AssemblyItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssemblyItemsId: Api['getV1AssemblyItemsId'] = async (request: Types.GetV1AssemblyItemsIdRequest): Promise<Types.GetV1AssemblyItemsIdResponses> => {
  return await _getV1AssemblyItemsId(baseUrl, request)
}
const _putV1AssemblyItemsId = async (url: string, request: Types.PutV1AssemblyItemsIdRequest): Promise<Types.PutV1AssemblyItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AssemblyItemsId: Api['putV1AssemblyItemsId'] = async (request: Types.PutV1AssemblyItemsIdRequest): Promise<Types.PutV1AssemblyItemsIdResponses> => {
  return await _putV1AssemblyItemsId(baseUrl, request)
}
const _deleteV1AssemblyItemsId = async (url: string, request: Types.DeleteV1AssemblyItemsIdRequest): Promise<Types.DeleteV1AssemblyItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssemblyItemsId: Api['deleteV1AssemblyItemsId'] = async (request: Types.DeleteV1AssemblyItemsIdRequest): Promise<Types.DeleteV1AssemblyItemsIdResponses> => {
  return await _deleteV1AssemblyItemsId(baseUrl, request)
}
const _postV1AssemblyItemsImport = async (url: string, request: Types.PostV1AssemblyItemsImportRequest): Promise<Types.PostV1AssemblyItemsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assembly-items/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssemblyItemsImport: Api['postV1AssemblyItemsImport'] = async (request: Types.PostV1AssemblyItemsImportRequest): Promise<Types.PostV1AssemblyItemsImportResponses> => {
  return await _postV1AssemblyItemsImport(baseUrl, request)
}
const _postV1Attributes = async (url: string, request: Types.PostV1AttributesRequest): Promise<Types.PostV1AttributesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Attributes: Api['postV1Attributes'] = async (request: Types.PostV1AttributesRequest): Promise<Types.PostV1AttributesResponses> => {
  return await _postV1Attributes(baseUrl, request)
}
const _getV1Attributes = async (url: string, request: Types.GetV1AttributesRequest): Promise<Types.GetV1AttributesResponses> => {
  const queryParameters: (keyof Types.GetV1AttributesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Attributes: Api['getV1Attributes'] = async (request: Types.GetV1AttributesRequest): Promise<Types.GetV1AttributesResponses> => {
  return await _getV1Attributes(baseUrl, request)
}
const _getV1AttributesId = async (url: string, request: Types.GetV1AttributesIdRequest): Promise<Types.GetV1AttributesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AttributesId: Api['getV1AttributesId'] = async (request: Types.GetV1AttributesIdRequest): Promise<Types.GetV1AttributesIdResponses> => {
  return await _getV1AttributesId(baseUrl, request)
}
const _putV1AttributesId = async (url: string, request: Types.PutV1AttributesIdRequest): Promise<Types.PutV1AttributesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AttributesId: Api['putV1AttributesId'] = async (request: Types.PutV1AttributesIdRequest): Promise<Types.PutV1AttributesIdResponses> => {
  return await _putV1AttributesId(baseUrl, request)
}
const _deleteV1AttributesId = async (url: string, request: Types.DeleteV1AttributesIdRequest): Promise<Types.DeleteV1AttributesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AttributesId: Api['deleteV1AttributesId'] = async (request: Types.DeleteV1AttributesIdRequest): Promise<Types.DeleteV1AttributesIdResponses> => {
  return await _deleteV1AttributesId(baseUrl, request)
}
const _getV1AttributesGenerateExcel = async (url: string, request: Types.GetV1AttributesGenerateExcelRequest): Promise<Types.GetV1AttributesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1AttributesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attributes/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AttributesGenerateExcel: Api['getV1AttributesGenerateExcel'] = async (request: Types.GetV1AttributesGenerateExcelRequest): Promise<Types.GetV1AttributesGenerateExcelResponses> => {
  return await _getV1AttributesGenerateExcel(baseUrl, request)
}
const _postV1DiscountItems = async (url: string, request: Types.PostV1DiscountItemsRequest): Promise<Types.PostV1DiscountItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DiscountItems: Api['postV1DiscountItems'] = async (request: Types.PostV1DiscountItemsRequest): Promise<Types.PostV1DiscountItemsResponses> => {
  return await _postV1DiscountItems(baseUrl, request)
}
const _getV1DiscountItems = async (url: string, request: Types.GetV1DiscountItemsRequest): Promise<Types.GetV1DiscountItemsResponses> => {
  const queryParameters: (keyof Types.GetV1DiscountItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DiscountItems: Api['getV1DiscountItems'] = async (request: Types.GetV1DiscountItemsRequest): Promise<Types.GetV1DiscountItemsResponses> => {
  return await _getV1DiscountItems(baseUrl, request)
}
const _getV1DiscountItemsId = async (url: string, request: Types.GetV1DiscountItemsIdRequest): Promise<Types.GetV1DiscountItemsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DiscountItemsId: Api['getV1DiscountItemsId'] = async (request: Types.GetV1DiscountItemsIdRequest): Promise<Types.GetV1DiscountItemsIdResponses> => {
  return await _getV1DiscountItemsId(baseUrl, request)
}
const _putV1DiscountItemsId = async (url: string, request: Types.PutV1DiscountItemsIdRequest): Promise<Types.PutV1DiscountItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DiscountItemsId: Api['putV1DiscountItemsId'] = async (request: Types.PutV1DiscountItemsIdRequest): Promise<Types.PutV1DiscountItemsIdResponses> => {
  return await _putV1DiscountItemsId(baseUrl, request)
}
const _deleteV1DiscountItemsId = async (url: string, request: Types.DeleteV1DiscountItemsIdRequest): Promise<Types.DeleteV1DiscountItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DiscountItemsId: Api['deleteV1DiscountItemsId'] = async (request: Types.DeleteV1DiscountItemsIdRequest): Promise<Types.DeleteV1DiscountItemsIdResponses> => {
  return await _deleteV1DiscountItemsId(baseUrl, request)
}
const _getV1DiscountItemsGenerateExcel = async (url: string, request: Types.GetV1DiscountItemsGenerateExcelRequest): Promise<Types.GetV1DiscountItemsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DiscountItemsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/discount-items/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DiscountItemsGenerateExcel: Api['getV1DiscountItemsGenerateExcel'] = async (request: Types.GetV1DiscountItemsGenerateExcelRequest): Promise<Types.GetV1DiscountItemsGenerateExcelResponses> => {
  return await _getV1DiscountItemsGenerateExcel(baseUrl, request)
}
const _postV1WarehouseLocation = async (url: string, request: Types.PostV1WarehouseLocationRequest): Promise<Types.PostV1WarehouseLocationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WarehouseLocation: Api['postV1WarehouseLocation'] = async (request: Types.PostV1WarehouseLocationRequest): Promise<Types.PostV1WarehouseLocationResponses> => {
  return await _postV1WarehouseLocation(baseUrl, request)
}
const _getV1WarehouseLocation = async (url: string, request: Types.GetV1WarehouseLocationRequest): Promise<Types.GetV1WarehouseLocationResponses> => {
  const queryParameters: (keyof Types.GetV1WarehouseLocationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WarehouseLocation: Api['getV1WarehouseLocation'] = async (request: Types.GetV1WarehouseLocationRequest): Promise<Types.GetV1WarehouseLocationResponses> => {
  return await _getV1WarehouseLocation(baseUrl, request)
}
const _getV1WarehouseLocationId = async (url: string, request: Types.GetV1WarehouseLocationIdRequest): Promise<Types.GetV1WarehouseLocationIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WarehouseLocationId: Api['getV1WarehouseLocationId'] = async (request: Types.GetV1WarehouseLocationIdRequest): Promise<Types.GetV1WarehouseLocationIdResponses> => {
  return await _getV1WarehouseLocationId(baseUrl, request)
}
const _putV1WarehouseLocationId = async (url: string, request: Types.PutV1WarehouseLocationIdRequest): Promise<Types.PutV1WarehouseLocationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WarehouseLocationId: Api['putV1WarehouseLocationId'] = async (request: Types.PutV1WarehouseLocationIdRequest): Promise<Types.PutV1WarehouseLocationIdResponses> => {
  return await _putV1WarehouseLocationId(baseUrl, request)
}
const _deleteV1WarehouseLocationId = async (url: string, request: Types.DeleteV1WarehouseLocationIdRequest): Promise<Types.DeleteV1WarehouseLocationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WarehouseLocationId: Api['deleteV1WarehouseLocationId'] = async (request: Types.DeleteV1WarehouseLocationIdRequest): Promise<Types.DeleteV1WarehouseLocationIdResponses> => {
  return await _deleteV1WarehouseLocationId(baseUrl, request)
}
const _getV1WarehouseLocationGenerateExcel = async (url: string, request: Types.GetV1WarehouseLocationGenerateExcelRequest): Promise<Types.GetV1WarehouseLocationGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1WarehouseLocationGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/warehouse-location/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WarehouseLocationGenerateExcel: Api['getV1WarehouseLocationGenerateExcel'] = async (request: Types.GetV1WarehouseLocationGenerateExcelRequest): Promise<Types.GetV1WarehouseLocationGenerateExcelResponses> => {
  return await _getV1WarehouseLocationGenerateExcel(baseUrl, request)
}
const _postV1RoutesRules = async (url: string, request: Types.PostV1RoutesRulesRequest): Promise<Types.PostV1RoutesRulesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RoutesRules: Api['postV1RoutesRules'] = async (request: Types.PostV1RoutesRulesRequest): Promise<Types.PostV1RoutesRulesResponses> => {
  return await _postV1RoutesRules(baseUrl, request)
}
const _getV1RoutesRules = async (url: string, request: Types.GetV1RoutesRulesRequest): Promise<Types.GetV1RoutesRulesResponses> => {
  const queryParameters: (keyof Types.GetV1RoutesRulesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutesRules: Api['getV1RoutesRules'] = async (request: Types.GetV1RoutesRulesRequest): Promise<Types.GetV1RoutesRulesResponses> => {
  return await _getV1RoutesRules(baseUrl, request)
}
const _getV1RoutesRulesId = async (url: string, request: Types.GetV1RoutesRulesIdRequest): Promise<Types.GetV1RoutesRulesIdResponses> => {
  const queryParameters: (keyof Types.GetV1RoutesRulesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutesRulesId: Api['getV1RoutesRulesId'] = async (request: Types.GetV1RoutesRulesIdRequest): Promise<Types.GetV1RoutesRulesIdResponses> => {
  return await _getV1RoutesRulesId(baseUrl, request)
}
const _putV1RoutesRulesId = async (url: string, request: Types.PutV1RoutesRulesIdRequest): Promise<Types.PutV1RoutesRulesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RoutesRulesId: Api['putV1RoutesRulesId'] = async (request: Types.PutV1RoutesRulesIdRequest): Promise<Types.PutV1RoutesRulesIdResponses> => {
  return await _putV1RoutesRulesId(baseUrl, request)
}
const _deleteV1RoutesRulesId = async (url: string, request: Types.DeleteV1RoutesRulesIdRequest): Promise<Types.DeleteV1RoutesRulesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RoutesRulesId: Api['deleteV1RoutesRulesId'] = async (request: Types.DeleteV1RoutesRulesIdRequest): Promise<Types.DeleteV1RoutesRulesIdResponses> => {
  return await _deleteV1RoutesRulesId(baseUrl, request)
}
const _getV1RoutesRulesOperationTypes = async (url: string, request: Types.GetV1RoutesRulesOperationTypesRequest): Promise<Types.GetV1RoutesRulesOperationTypesResponses> => {
  const queryParameters: (keyof Types.GetV1RoutesRulesOperationTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/operation-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutesRulesOperationTypes: Api['getV1RoutesRulesOperationTypes'] = async (request: Types.GetV1RoutesRulesOperationTypesRequest): Promise<Types.GetV1RoutesRulesOperationTypesResponses> => {
  return await _getV1RoutesRulesOperationTypes(baseUrl, request)
}
const _getV1RoutesRulesWarehouses = async (url: string, request: Types.GetV1RoutesRulesWarehousesRequest): Promise<Types.GetV1RoutesRulesWarehousesResponses> => {
  const queryParameters: (keyof Types.GetV1RoutesRulesWarehousesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routes-rules/warehouses?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutesRulesWarehouses: Api['getV1RoutesRulesWarehouses'] = async (request: Types.GetV1RoutesRulesWarehousesRequest): Promise<Types.GetV1RoutesRulesWarehousesResponses> => {
  return await _getV1RoutesRulesWarehouses(baseUrl, request)
}
const _postV1Bin = async (url: string, request: Types.PostV1BinRequest): Promise<Types.PostV1BinResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Bin: Api['postV1Bin'] = async (request: Types.PostV1BinRequest): Promise<Types.PostV1BinResponses> => {
  return await _postV1Bin(baseUrl, request)
}
const _getV1Bin = async (url: string, request: Types.GetV1BinRequest): Promise<Types.GetV1BinResponses> => {
  const queryParameters: (keyof Types.GetV1BinRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Bin: Api['getV1Bin'] = async (request: Types.GetV1BinRequest): Promise<Types.GetV1BinResponses> => {
  return await _getV1Bin(baseUrl, request)
}
const _getV1BinId = async (url: string, request: Types.GetV1BinIdRequest): Promise<Types.GetV1BinIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinId: Api['getV1BinId'] = async (request: Types.GetV1BinIdRequest): Promise<Types.GetV1BinIdResponses> => {
  return await _getV1BinId(baseUrl, request)
}
const _putV1BinId = async (url: string, request: Types.PutV1BinIdRequest): Promise<Types.PutV1BinIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BinId: Api['putV1BinId'] = async (request: Types.PutV1BinIdRequest): Promise<Types.PutV1BinIdResponses> => {
  return await _putV1BinId(baseUrl, request)
}
const _deleteV1BinId = async (url: string, request: Types.DeleteV1BinIdRequest): Promise<Types.DeleteV1BinIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BinId: Api['deleteV1BinId'] = async (request: Types.DeleteV1BinIdRequest): Promise<Types.DeleteV1BinIdResponses> => {
  return await _deleteV1BinId(baseUrl, request)
}
const _getV1BinGenerateExcel = async (url: string, request: Types.GetV1BinGenerateExcelRequest): Promise<Types.GetV1BinGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BinGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinGenerateExcel: Api['getV1BinGenerateExcel'] = async (request: Types.GetV1BinGenerateExcelRequest): Promise<Types.GetV1BinGenerateExcelResponses> => {
  return await _getV1BinGenerateExcel(baseUrl, request)
}
const _postV1UomTemplates = async (url: string, request: Types.PostV1UomTemplatesRequest): Promise<Types.PostV1UomTemplatesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/templates`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UomTemplates: Api['postV1UomTemplates'] = async (request: Types.PostV1UomTemplatesRequest): Promise<Types.PostV1UomTemplatesResponses> => {
  return await _postV1UomTemplates(baseUrl, request)
}
const _getV1UomTemplates = async (url: string, request: Types.GetV1UomTemplatesRequest): Promise<Types.GetV1UomTemplatesResponses> => {
  const queryParameters: (keyof Types.GetV1UomTemplatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/templates?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UomTemplates: Api['getV1UomTemplates'] = async (request: Types.GetV1UomTemplatesRequest): Promise<Types.GetV1UomTemplatesResponses> => {
  return await _getV1UomTemplates(baseUrl, request)
}
const _getV1Uom = async (url: string, request: Types.GetV1UomRequest): Promise<Types.GetV1UomResponses> => {
  const queryParameters: (keyof Types.GetV1UomRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Uom: Api['getV1Uom'] = async (request: Types.GetV1UomRequest): Promise<Types.GetV1UomResponses> => {
  return await _getV1Uom(baseUrl, request)
}
const _getV1UomTemplatesId = async (url: string, request: Types.GetV1UomTemplatesIdRequest): Promise<Types.GetV1UomTemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/templates/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UomTemplatesId: Api['getV1UomTemplatesId'] = async (request: Types.GetV1UomTemplatesIdRequest): Promise<Types.GetV1UomTemplatesIdResponses> => {
  return await _getV1UomTemplatesId(baseUrl, request)
}
const _putV1UomTemplatesId = async (url: string, request: Types.PutV1UomTemplatesIdRequest): Promise<Types.PutV1UomTemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/templates/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1UomTemplatesId: Api['putV1UomTemplatesId'] = async (request: Types.PutV1UomTemplatesIdRequest): Promise<Types.PutV1UomTemplatesIdResponses> => {
  return await _putV1UomTemplatesId(baseUrl, request)
}
const _deleteV1UomTemplatesId = async (url: string, request: Types.DeleteV1UomTemplatesIdRequest): Promise<Types.DeleteV1UomTemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/templates/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1UomTemplatesId: Api['deleteV1UomTemplatesId'] = async (request: Types.DeleteV1UomTemplatesIdRequest): Promise<Types.DeleteV1UomTemplatesIdResponses> => {
  return await _deleteV1UomTemplatesId(baseUrl, request)
}
const _deleteV1UomUnitsId = async (url: string, request: Types.DeleteV1UomUnitsIdRequest): Promise<Types.DeleteV1UomUnitsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/units/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1UomUnitsId: Api['deleteV1UomUnitsId'] = async (request: Types.DeleteV1UomUnitsIdRequest): Promise<Types.DeleteV1UomUnitsIdResponses> => {
  return await _deleteV1UomUnitsId(baseUrl, request)
}
const _getV1UomGenerateExcel = async (url: string, request: Types.GetV1UomGenerateExcelRequest): Promise<Types.GetV1UomGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1UomGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UomGenerateExcel: Api['getV1UomGenerateExcel'] = async (request: Types.GetV1UomGenerateExcelRequest): Promise<Types.GetV1UomGenerateExcelResponses> => {
  return await _getV1UomGenerateExcel(baseUrl, request)
}
const _getV1UomUnitsIdCheckConversionFactor = async (url: string, request: Types.GetV1UomUnitsIdCheckConversionFactorRequest): Promise<Types.GetV1UomUnitsIdCheckConversionFactorResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/uom/units/${request['id']}/check-conversion-factor`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UomUnitsIdCheckConversionFactor: Api['getV1UomUnitsIdCheckConversionFactor'] = async (request: Types.GetV1UomUnitsIdCheckConversionFactorRequest): Promise<Types.GetV1UomUnitsIdCheckConversionFactorResponses> => {
  return await _getV1UomUnitsIdCheckConversionFactor(baseUrl, request)
}
const _postV1CategoryItems = async (url: string, request: Types.PostV1CategoryItemsRequest): Promise<Types.PostV1CategoryItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CategoryItems: Api['postV1CategoryItems'] = async (request: Types.PostV1CategoryItemsRequest): Promise<Types.PostV1CategoryItemsResponses> => {
  return await _postV1CategoryItems(baseUrl, request)
}
const _getV1CategoryItems = async (url: string, request: Types.GetV1CategoryItemsRequest): Promise<Types.GetV1CategoryItemsResponses> => {
  const queryParameters: (keyof Types.GetV1CategoryItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CategoryItems: Api['getV1CategoryItems'] = async (request: Types.GetV1CategoryItemsRequest): Promise<Types.GetV1CategoryItemsResponses> => {
  return await _getV1CategoryItems(baseUrl, request)
}
const _getV1CategoryItemsId = async (url: string, request: Types.GetV1CategoryItemsIdRequest): Promise<Types.GetV1CategoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CategoryItemsId: Api['getV1CategoryItemsId'] = async (request: Types.GetV1CategoryItemsIdRequest): Promise<Types.GetV1CategoryItemsIdResponses> => {
  return await _getV1CategoryItemsId(baseUrl, request)
}
const _putV1CategoryItemsId = async (url: string, request: Types.PutV1CategoryItemsIdRequest): Promise<Types.PutV1CategoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CategoryItemsId: Api['putV1CategoryItemsId'] = async (request: Types.PutV1CategoryItemsIdRequest): Promise<Types.PutV1CategoryItemsIdResponses> => {
  return await _putV1CategoryItemsId(baseUrl, request)
}
const _deleteV1CategoryItemsId = async (url: string, request: Types.DeleteV1CategoryItemsIdRequest): Promise<Types.DeleteV1CategoryItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CategoryItemsId: Api['deleteV1CategoryItemsId'] = async (request: Types.DeleteV1CategoryItemsIdRequest): Promise<Types.DeleteV1CategoryItemsIdResponses> => {
  return await _deleteV1CategoryItemsId(baseUrl, request)
}
const _getV1CategoryItemsGenerateExcel = async (url: string, request: Types.GetV1CategoryItemsGenerateExcelRequest): Promise<Types.GetV1CategoryItemsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CategoryItemsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/category-items/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CategoryItemsGenerateExcel: Api['getV1CategoryItemsGenerateExcel'] = async (request: Types.GetV1CategoryItemsGenerateExcelRequest): Promise<Types.GetV1CategoryItemsGenerateExcelResponses> => {
  return await _getV1CategoryItemsGenerateExcel(baseUrl, request)
}
const _postV1PackageItems = async (url: string, request: Types.PostV1PackageItemsRequest): Promise<Types.PostV1PackageItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/package-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PackageItems: Api['postV1PackageItems'] = async (request: Types.PostV1PackageItemsRequest): Promise<Types.PostV1PackageItemsResponses> => {
  return await _postV1PackageItems(baseUrl, request)
}
const _getV1PackageItems = async (url: string, request: Types.GetV1PackageItemsRequest): Promise<Types.GetV1PackageItemsResponses> => {
  const queryParameters: (keyof Types.GetV1PackageItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/package-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PackageItems: Api['getV1PackageItems'] = async (request: Types.GetV1PackageItemsRequest): Promise<Types.GetV1PackageItemsResponses> => {
  return await _getV1PackageItems(baseUrl, request)
}
const _getV1PackageItemsId = async (url: string, request: Types.GetV1PackageItemsIdRequest): Promise<Types.GetV1PackageItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PackageItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/package-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PackageItemsId: Api['getV1PackageItemsId'] = async (request: Types.GetV1PackageItemsIdRequest): Promise<Types.GetV1PackageItemsIdResponses> => {
  return await _getV1PackageItemsId(baseUrl, request)
}
const _putV1PackageItemsId = async (url: string, request: Types.PutV1PackageItemsIdRequest): Promise<Types.PutV1PackageItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/package-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PackageItemsId: Api['putV1PackageItemsId'] = async (request: Types.PutV1PackageItemsIdRequest): Promise<Types.PutV1PackageItemsIdResponses> => {
  return await _putV1PackageItemsId(baseUrl, request)
}
const _deleteV1PackageItemsId = async (url: string, request: Types.DeleteV1PackageItemsIdRequest): Promise<Types.DeleteV1PackageItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/package-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PackageItemsId: Api['deleteV1PackageItemsId'] = async (request: Types.DeleteV1PackageItemsIdRequest): Promise<Types.DeleteV1PackageItemsIdResponses> => {
  return await _deleteV1PackageItemsId(baseUrl, request)
}
const _postV1InventoryAdjustment = async (url: string, request: Types.PostV1InventoryAdjustmentRequest): Promise<Types.PostV1InventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryAdjustment: Api['postV1InventoryAdjustment'] = async (request: Types.PostV1InventoryAdjustmentRequest): Promise<Types.PostV1InventoryAdjustmentResponses> => {
  return await _postV1InventoryAdjustment(baseUrl, request)
}
const _getV1InventoryAdjustment = async (url: string, request: Types.GetV1InventoryAdjustmentRequest): Promise<Types.GetV1InventoryAdjustmentResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryAdjustmentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryAdjustment: Api['getV1InventoryAdjustment'] = async (request: Types.GetV1InventoryAdjustmentRequest): Promise<Types.GetV1InventoryAdjustmentResponses> => {
  return await _getV1InventoryAdjustment(baseUrl, request)
}
const _getV1InventoryAdjustmentId = async (url: string, request: Types.GetV1InventoryAdjustmentIdRequest): Promise<Types.GetV1InventoryAdjustmentIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryAdjustmentId: Api['getV1InventoryAdjustmentId'] = async (request: Types.GetV1InventoryAdjustmentIdRequest): Promise<Types.GetV1InventoryAdjustmentIdResponses> => {
  return await _getV1InventoryAdjustmentId(baseUrl, request)
}
const _putV1InventoryAdjustmentId = async (url: string, request: Types.PutV1InventoryAdjustmentIdRequest): Promise<Types.PutV1InventoryAdjustmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InventoryAdjustmentId: Api['putV1InventoryAdjustmentId'] = async (request: Types.PutV1InventoryAdjustmentIdRequest): Promise<Types.PutV1InventoryAdjustmentIdResponses> => {
  return await _putV1InventoryAdjustmentId(baseUrl, request)
}
const _deleteV1InventoryAdjustmentId = async (url: string, request: Types.DeleteV1InventoryAdjustmentIdRequest): Promise<Types.DeleteV1InventoryAdjustmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1InventoryAdjustmentId: Api['deleteV1InventoryAdjustmentId'] = async (request: Types.DeleteV1InventoryAdjustmentIdRequest): Promise<Types.DeleteV1InventoryAdjustmentIdResponses> => {
  return await _deleteV1InventoryAdjustmentId(baseUrl, request)
}
const _putV1InventoryAdjustmentIdItemItemIdStockStockId = async (url: string, request: Types.PutV1InventoryAdjustmentIdItemItemIdStockStockIdRequest): Promise<Types.PutV1InventoryAdjustmentIdItemItemIdStockStockIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/${request['id']}/item/${request['itemId']}/stock/${request['stockId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InventoryAdjustmentIdItemItemIdStockStockId: Api['putV1InventoryAdjustmentIdItemItemIdStockStockId'] = async (request: Types.PutV1InventoryAdjustmentIdItemItemIdStockStockIdRequest): Promise<Types.PutV1InventoryAdjustmentIdItemItemIdStockStockIdResponses> => {
  return await _putV1InventoryAdjustmentIdItemItemIdStockStockId(baseUrl, request)
}
const _getV1InventoryAdjustmentIdDownload = async (url: string, request: Types.GetV1InventoryAdjustmentIdDownloadRequest): Promise<Types.GetV1InventoryAdjustmentIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryAdjustmentIdDownload: Api['getV1InventoryAdjustmentIdDownload'] = async (request: Types.GetV1InventoryAdjustmentIdDownloadRequest): Promise<Types.GetV1InventoryAdjustmentIdDownloadResponses> => {
  return await _getV1InventoryAdjustmentIdDownload(baseUrl, request)
}
const _getV1InventoryAdjustmentGenerateExcel = async (url: string, request: Types.GetV1InventoryAdjustmentGenerateExcelRequest): Promise<Types.GetV1InventoryAdjustmentGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryAdjustmentGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-adjustment/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryAdjustmentGenerateExcel: Api['getV1InventoryAdjustmentGenerateExcel'] = async (request: Types.GetV1InventoryAdjustmentGenerateExcelRequest): Promise<Types.GetV1InventoryAdjustmentGenerateExcelResponses> => {
  return await _getV1InventoryAdjustmentGenerateExcel(baseUrl, request)
}
const _postV1ServiceItems = async (url: string, request: Types.PostV1ServiceItemsRequest): Promise<Types.PostV1ServiceItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/service-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ServiceItems: Api['postV1ServiceItems'] = async (request: Types.PostV1ServiceItemsRequest): Promise<Types.PostV1ServiceItemsResponses> => {
  return await _postV1ServiceItems(baseUrl, request)
}
const _getV1ServiceItems = async (url: string, request: Types.GetV1ServiceItemsRequest): Promise<Types.GetV1ServiceItemsResponses> => {
  const queryParameters: (keyof Types.GetV1ServiceItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/service-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ServiceItems: Api['getV1ServiceItems'] = async (request: Types.GetV1ServiceItemsRequest): Promise<Types.GetV1ServiceItemsResponses> => {
  return await _getV1ServiceItems(baseUrl, request)
}
const _getV1ServiceItemsId = async (url: string, request: Types.GetV1ServiceItemsIdRequest): Promise<Types.GetV1ServiceItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ServiceItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/service-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ServiceItemsId: Api['getV1ServiceItemsId'] = async (request: Types.GetV1ServiceItemsIdRequest): Promise<Types.GetV1ServiceItemsIdResponses> => {
  return await _getV1ServiceItemsId(baseUrl, request)
}
const _putV1ServiceItemsId = async (url: string, request: Types.PutV1ServiceItemsIdRequest): Promise<Types.PutV1ServiceItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/service-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ServiceItemsId: Api['putV1ServiceItemsId'] = async (request: Types.PutV1ServiceItemsIdRequest): Promise<Types.PutV1ServiceItemsIdResponses> => {
  return await _putV1ServiceItemsId(baseUrl, request)
}
const _deleteV1ServiceItemsId = async (url: string, request: Types.DeleteV1ServiceItemsIdRequest): Promise<Types.DeleteV1ServiceItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/service-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ServiceItemsId: Api['deleteV1ServiceItemsId'] = async (request: Types.DeleteV1ServiceItemsIdRequest): Promise<Types.DeleteV1ServiceItemsIdResponses> => {
  return await _deleteV1ServiceItemsId(baseUrl, request)
}
const _getV1Brand = async (url: string, request: Types.GetV1BrandRequest): Promise<Types.GetV1BrandResponses> => {
  const queryParameters: (keyof Types.GetV1BrandRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/brand/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Brand: Api['getV1Brand'] = async (request: Types.GetV1BrandRequest): Promise<Types.GetV1BrandResponses> => {
  return await _getV1Brand(baseUrl, request)
}
const _postV1Brand = async (url: string, request: Types.PostV1BrandRequest): Promise<Types.PostV1BrandResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/brand/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Brand: Api['postV1Brand'] = async (request: Types.PostV1BrandRequest): Promise<Types.PostV1BrandResponses> => {
  return await _postV1Brand(baseUrl, request)
}
const _postV1BinTransfer = async (url: string, request: Types.PostV1BinTransferRequest): Promise<Types.PostV1BinTransferResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BinTransfer: Api['postV1BinTransfer'] = async (request: Types.PostV1BinTransferRequest): Promise<Types.PostV1BinTransferResponses> => {
  return await _postV1BinTransfer(baseUrl, request)
}
const _getV1BinTransfer = async (url: string, request: Types.GetV1BinTransferRequest): Promise<Types.GetV1BinTransferResponses> => {
  const queryParameters: (keyof Types.GetV1BinTransferRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinTransfer: Api['getV1BinTransfer'] = async (request: Types.GetV1BinTransferRequest): Promise<Types.GetV1BinTransferResponses> => {
  return await _getV1BinTransfer(baseUrl, request)
}
const _getV1BinTransferId = async (url: string, request: Types.GetV1BinTransferIdRequest): Promise<Types.GetV1BinTransferIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinTransferId: Api['getV1BinTransferId'] = async (request: Types.GetV1BinTransferIdRequest): Promise<Types.GetV1BinTransferIdResponses> => {
  return await _getV1BinTransferId(baseUrl, request)
}
const _putV1BinTransferId = async (url: string, request: Types.PutV1BinTransferIdRequest): Promise<Types.PutV1BinTransferIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BinTransferId: Api['putV1BinTransferId'] = async (request: Types.PutV1BinTransferIdRequest): Promise<Types.PutV1BinTransferIdResponses> => {
  return await _putV1BinTransferId(baseUrl, request)
}
const _deleteV1BinTransferId = async (url: string, request: Types.DeleteV1BinTransferIdRequest): Promise<Types.DeleteV1BinTransferIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BinTransferId: Api['deleteV1BinTransferId'] = async (request: Types.DeleteV1BinTransferIdRequest): Promise<Types.DeleteV1BinTransferIdResponses> => {
  return await _deleteV1BinTransferId(baseUrl, request)
}
const _getV1BinTransferTrackingId = async (url: string, request: Types.GetV1BinTransferTrackingIdRequest): Promise<Types.GetV1BinTransferTrackingIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/tracking/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinTransferTrackingId: Api['getV1BinTransferTrackingId'] = async (request: Types.GetV1BinTransferTrackingIdRequest): Promise<Types.GetV1BinTransferTrackingIdResponses> => {
  return await _getV1BinTransferTrackingId(baseUrl, request)
}
const _putV1BinTransferUpdateTrackingId = async (url: string, request: Types.PutV1BinTransferUpdateTrackingIdRequest): Promise<Types.PutV1BinTransferUpdateTrackingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/update-tracking/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BinTransferUpdateTrackingId: Api['putV1BinTransferUpdateTrackingId'] = async (request: Types.PutV1BinTransferUpdateTrackingIdRequest): Promise<Types.PutV1BinTransferUpdateTrackingIdResponses> => {
  return await _putV1BinTransferUpdateTrackingId(baseUrl, request)
}
const _putV1BinTransferUpdateStatusId = async (url: string, request: Types.PutV1BinTransferUpdateStatusIdRequest): Promise<Types.PutV1BinTransferUpdateStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/update-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BinTransferUpdateStatusId: Api['putV1BinTransferUpdateStatusId'] = async (request: Types.PutV1BinTransferUpdateStatusIdRequest): Promise<Types.PutV1BinTransferUpdateStatusIdResponses> => {
  return await _putV1BinTransferUpdateStatusId(baseUrl, request)
}
const _getV1BinTransferGenerateExcel = async (url: string, request: Types.GetV1BinTransferGenerateExcelRequest): Promise<Types.GetV1BinTransferGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BinTransferGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bin-transfer/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BinTransferGenerateExcel: Api['getV1BinTransferGenerateExcel'] = async (request: Types.GetV1BinTransferGenerateExcelRequest): Promise<Types.GetV1BinTransferGenerateExcelResponses> => {
  return await _getV1BinTransferGenerateExcel(baseUrl, request)
}
const _postV1StockTransfers = async (url: string, request: Types.PostV1StockTransfersRequest): Promise<Types.PostV1StockTransfersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1StockTransfers: Api['postV1StockTransfers'] = async (request: Types.PostV1StockTransfersRequest): Promise<Types.PostV1StockTransfersResponses> => {
  return await _postV1StockTransfers(baseUrl, request)
}
const _getV1StockTransfers = async (url: string, request: Types.GetV1StockTransfersRequest): Promise<Types.GetV1StockTransfersResponses> => {
  const queryParameters: (keyof Types.GetV1StockTransfersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfers: Api['getV1StockTransfers'] = async (request: Types.GetV1StockTransfersRequest): Promise<Types.GetV1StockTransfersResponses> => {
  return await _getV1StockTransfers(baseUrl, request)
}
const _getV1StockTransfersOperationType = async (url: string, request: Types.GetV1StockTransfersOperationTypeRequest): Promise<Types.GetV1StockTransfersOperationTypeResponses> => {
  const queryParameters: (keyof Types.GetV1StockTransfersOperationTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/operation-type?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfersOperationType: Api['getV1StockTransfersOperationType'] = async (request: Types.GetV1StockTransfersOperationTypeRequest): Promise<Types.GetV1StockTransfersOperationTypeResponses> => {
  return await _getV1StockTransfersOperationType(baseUrl, request)
}
const _getV1StockTransfersId = async (url: string, request: Types.GetV1StockTransfersIdRequest): Promise<Types.GetV1StockTransfersIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfersId: Api['getV1StockTransfersId'] = async (request: Types.GetV1StockTransfersIdRequest): Promise<Types.GetV1StockTransfersIdResponses> => {
  return await _getV1StockTransfersId(baseUrl, request)
}
const _putV1StockTransfersId = async (url: string, request: Types.PutV1StockTransfersIdRequest): Promise<Types.PutV1StockTransfersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockTransfersId: Api['putV1StockTransfersId'] = async (request: Types.PutV1StockTransfersIdRequest): Promise<Types.PutV1StockTransfersIdResponses> => {
  return await _putV1StockTransfersId(baseUrl, request)
}
const _deleteV1StockTransfersId = async (url: string, request: Types.DeleteV1StockTransfersIdRequest): Promise<Types.DeleteV1StockTransfersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1StockTransfersId: Api['deleteV1StockTransfersId'] = async (request: Types.DeleteV1StockTransfersIdRequest): Promise<Types.DeleteV1StockTransfersIdResponses> => {
  return await _deleteV1StockTransfersId(baseUrl, request)
}
const _getV1StockTransfersTrackingId = async (url: string, request: Types.GetV1StockTransfersTrackingIdRequest): Promise<Types.GetV1StockTransfersTrackingIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/tracking/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfersTrackingId: Api['getV1StockTransfersTrackingId'] = async (request: Types.GetV1StockTransfersTrackingIdRequest): Promise<Types.GetV1StockTransfersTrackingIdResponses> => {
  return await _getV1StockTransfersTrackingId(baseUrl, request)
}
const _putV1StockTransfersUpdateTrackingId = async (url: string, request: Types.PutV1StockTransfersUpdateTrackingIdRequest): Promise<Types.PutV1StockTransfersUpdateTrackingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/update-tracking/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockTransfersUpdateTrackingId: Api['putV1StockTransfersUpdateTrackingId'] = async (request: Types.PutV1StockTransfersUpdateTrackingIdRequest): Promise<Types.PutV1StockTransfersUpdateTrackingIdResponses> => {
  return await _putV1StockTransfersUpdateTrackingId(baseUrl, request)
}
const _putV1StockTransfersUpdateTrackingDetailsId = async (url: string, request: Types.PutV1StockTransfersUpdateTrackingDetailsIdRequest): Promise<Types.PutV1StockTransfersUpdateTrackingDetailsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/update-tracking-details/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockTransfersUpdateTrackingDetailsId: Api['putV1StockTransfersUpdateTrackingDetailsId'] = async (request: Types.PutV1StockTransfersUpdateTrackingDetailsIdRequest): Promise<Types.PutV1StockTransfersUpdateTrackingDetailsIdResponses> => {
  return await _putV1StockTransfersUpdateTrackingDetailsId(baseUrl, request)
}
const _putV1StockTransfersUpdateStatusId = async (url: string, request: Types.PutV1StockTransfersUpdateStatusIdRequest): Promise<Types.PutV1StockTransfersUpdateStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/update-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockTransfersUpdateStatusId: Api['putV1StockTransfersUpdateStatusId'] = async (request: Types.PutV1StockTransfersUpdateStatusIdRequest): Promise<Types.PutV1StockTransfersUpdateStatusIdResponses> => {
  return await _putV1StockTransfersUpdateStatusId(baseUrl, request)
}
const _getV1StockTransfersIdDownload = async (url: string, request: Types.GetV1StockTransfersIdDownloadRequest): Promise<Types.GetV1StockTransfersIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfersIdDownload: Api['getV1StockTransfersIdDownload'] = async (request: Types.GetV1StockTransfersIdDownloadRequest): Promise<Types.GetV1StockTransfersIdDownloadResponses> => {
  return await _getV1StockTransfersIdDownload(baseUrl, request)
}
const _getV1StockTransfersGenerateExcel = async (url: string, request: Types.GetV1StockTransfersGenerateExcelRequest): Promise<Types.GetV1StockTransfersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1StockTransfersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockTransfersGenerateExcel: Api['getV1StockTransfersGenerateExcel'] = async (request: Types.GetV1StockTransfersGenerateExcelRequest): Promise<Types.GetV1StockTransfersGenerateExcelResponses> => {
  return await _getV1StockTransfersGenerateExcel(baseUrl, request)
}
const _postV1StockTransfersIdAddApprover = async (url: string, request: Types.PostV1StockTransfersIdAddApproverRequest): Promise<Types.PostV1StockTransfersIdAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1StockTransfersIdAddApprover: Api['postV1StockTransfersIdAddApprover'] = async (request: Types.PostV1StockTransfersIdAddApproverRequest): Promise<Types.PostV1StockTransfersIdAddApproverResponses> => {
  return await _postV1StockTransfersIdAddApprover(baseUrl, request)
}
const _putV1StockTransfersIdApprovalStatusApprovalId = async (url: string, request: Types.PutV1StockTransfersIdApprovalStatusApprovalIdRequest): Promise<Types.PutV1StockTransfersIdApprovalStatusApprovalIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-transfers/${request['id']}/approval-status/${request['approval_id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockTransfersIdApprovalStatusApprovalId: Api['putV1StockTransfersIdApprovalStatusApprovalId'] = async (request: Types.PutV1StockTransfersIdApprovalStatusApprovalIdRequest): Promise<Types.PutV1StockTransfersIdApprovalStatusApprovalIdResponses> => {
  return await _putV1StockTransfersIdApprovalStatusApprovalId(baseUrl, request)
}
const _postV1Stock = async (url: string, request: Types.PostV1StockRequest): Promise<Types.PostV1StockResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Stock: Api['postV1Stock'] = async (request: Types.PostV1StockRequest): Promise<Types.PostV1StockResponses> => {
  return await _postV1Stock(baseUrl, request)
}
const _getV1Stock = async (url: string, request: Types.GetV1StockRequest): Promise<Types.GetV1StockResponses> => {
  const queryParameters: (keyof Types.GetV1StockRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Stock: Api['getV1Stock'] = async (request: Types.GetV1StockRequest): Promise<Types.GetV1StockResponses> => {
  return await _getV1Stock(baseUrl, request)
}
const _getV1StockId = async (url: string, request: Types.GetV1StockIdRequest): Promise<Types.GetV1StockIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockId: Api['getV1StockId'] = async (request: Types.GetV1StockIdRequest): Promise<Types.GetV1StockIdResponses> => {
  return await _getV1StockId(baseUrl, request)
}
const _putV1StockId = async (url: string, request: Types.PutV1StockIdRequest): Promise<Types.PutV1StockIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1StockId: Api['putV1StockId'] = async (request: Types.PutV1StockIdRequest): Promise<Types.PutV1StockIdResponses> => {
  return await _putV1StockId(baseUrl, request)
}
const _deleteV1StockId = async (url: string, request: Types.DeleteV1StockIdRequest): Promise<Types.DeleteV1StockIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1StockId: Api['deleteV1StockId'] = async (request: Types.DeleteV1StockIdRequest): Promise<Types.DeleteV1StockIdResponses> => {
  return await _deleteV1StockId(baseUrl, request)
}
const _postV1StockGenerateSerials = async (url: string, request: Types.PostV1StockGenerateSerialsRequest): Promise<Types.PostV1StockGenerateSerialsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock/generate-serials`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1StockGenerateSerials: Api['postV1StockGenerateSerials'] = async (request: Types.PostV1StockGenerateSerialsRequest): Promise<Types.PostV1StockGenerateSerialsResponses> => {
  return await _postV1StockGenerateSerials(baseUrl, request)
}
const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _postV1Scrap = async (url: string, request: Types.PostV1ScrapRequest): Promise<Types.PostV1ScrapResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Scrap: Api['postV1Scrap'] = async (request: Types.PostV1ScrapRequest): Promise<Types.PostV1ScrapResponses> => {
  return await _postV1Scrap(baseUrl, request)
}
const _getV1Scrap = async (url: string, request: Types.GetV1ScrapRequest): Promise<Types.GetV1ScrapResponses> => {
  const queryParameters: (keyof Types.GetV1ScrapRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Scrap: Api['getV1Scrap'] = async (request: Types.GetV1ScrapRequest): Promise<Types.GetV1ScrapResponses> => {
  return await _getV1Scrap(baseUrl, request)
}
const _getV1ScrapId = async (url: string, request: Types.GetV1ScrapIdRequest): Promise<Types.GetV1ScrapIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ScrapId: Api['getV1ScrapId'] = async (request: Types.GetV1ScrapIdRequest): Promise<Types.GetV1ScrapIdResponses> => {
  return await _getV1ScrapId(baseUrl, request)
}
const _putV1ScrapId = async (url: string, request: Types.PutV1ScrapIdRequest): Promise<Types.PutV1ScrapIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ScrapId: Api['putV1ScrapId'] = async (request: Types.PutV1ScrapIdRequest): Promise<Types.PutV1ScrapIdResponses> => {
  return await _putV1ScrapId(baseUrl, request)
}
const _deleteV1ScrapId = async (url: string, request: Types.DeleteV1ScrapIdRequest): Promise<Types.DeleteV1ScrapIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ScrapId: Api['deleteV1ScrapId'] = async (request: Types.DeleteV1ScrapIdRequest): Promise<Types.DeleteV1ScrapIdResponses> => {
  return await _deleteV1ScrapId(baseUrl, request)
}
const _deleteV1ScrapScrapEntryId = async (url: string, request: Types.DeleteV1ScrapScrapEntryIdRequest): Promise<Types.DeleteV1ScrapScrapEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scrap/scrap-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ScrapScrapEntryId: Api['deleteV1ScrapScrapEntryId'] = async (request: Types.DeleteV1ScrapScrapEntryIdRequest): Promise<Types.DeleteV1ScrapScrapEntryIdResponses> => {
  return await _deleteV1ScrapScrapEntryId(baseUrl, request)
}
const _getV1StockReason = async (url: string, request: Types.GetV1StockReasonRequest): Promise<Types.GetV1StockReasonResponses> => {
  const queryParameters: (keyof Types.GetV1StockReasonRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-reason/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1StockReason: Api['getV1StockReason'] = async (request: Types.GetV1StockReasonRequest): Promise<Types.GetV1StockReasonResponses> => {
  return await _getV1StockReason(baseUrl, request)
}
const _postV1StockReason = async (url: string, request: Types.PostV1StockReasonRequest): Promise<Types.PostV1StockReasonResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/stock-reason/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1StockReason: Api['postV1StockReason'] = async (request: Types.PostV1StockReasonRequest): Promise<Types.PostV1StockReasonResponses> => {
  return await _postV1StockReason(baseUrl, request)
}
const _postV1ReportsInventoryValuationReport = async (url: string, request: Types.PostV1ReportsInventoryValuationReportRequest): Promise<Types.PostV1ReportsInventoryValuationReportResponses> => {
  const queryParameters: (keyof Types.PostV1ReportsInventoryValuationReportRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/inventory-valuation-report?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsInventoryValuationReport: Api['postV1ReportsInventoryValuationReport'] = async (request: Types.PostV1ReportsInventoryValuationReportRequest): Promise<Types.PostV1ReportsInventoryValuationReportResponses> => {
  return await _postV1ReportsInventoryValuationReport(baseUrl, request)
}
const _postV1ReportsInventoryValuationChart = async (url: string, request: Types.PostV1ReportsInventoryValuationChartRequest): Promise<Types.PostV1ReportsInventoryValuationChartResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/inventory-valuation-chart`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsInventoryValuationChart: Api['postV1ReportsInventoryValuationChart'] = async (request: Types.PostV1ReportsInventoryValuationChartRequest): Promise<Types.PostV1ReportsInventoryValuationChartResponses> => {
  return await _postV1ReportsInventoryValuationChart(baseUrl, request)
}
const _postV1ReportsStockStatusReport = async (url: string, request: Types.PostV1ReportsStockStatusReportRequest): Promise<Types.PostV1ReportsStockStatusReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/stock-status-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsStockStatusReport: Api['postV1ReportsStockStatusReport'] = async (request: Types.PostV1ReportsStockStatusReportRequest): Promise<Types.PostV1ReportsStockStatusReportResponses> => {
  return await _postV1ReportsStockStatusReport(baseUrl, request)
}
const _postV1ReportsStockStatusChart = async (url: string, request: Types.PostV1ReportsStockStatusChartRequest): Promise<Types.PostV1ReportsStockStatusChartResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/stock-status-chart`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsStockStatusChart: Api['postV1ReportsStockStatusChart'] = async (request: Types.PostV1ReportsStockStatusChartRequest): Promise<Types.PostV1ReportsStockStatusChartResponses> => {
  return await _postV1ReportsStockStatusChart(baseUrl, request)
}
const _postV1ReportsReorderReport = async (url: string, request: Types.PostV1ReportsReorderReportRequest): Promise<Types.PostV1ReportsReorderReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/reorder-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsReorderReport: Api['postV1ReportsReorderReport'] = async (request: Types.PostV1ReportsReorderReportRequest): Promise<Types.PostV1ReportsReorderReportResponses> => {
  return await _postV1ReportsReorderReport(baseUrl, request)
}
const _postV1ReportsReorderChart = async (url: string, request: Types.PostV1ReportsReorderChartRequest): Promise<Types.PostV1ReportsReorderChartResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/reorder-chart`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsReorderChart: Api['postV1ReportsReorderChart'] = async (request: Types.PostV1ReportsReorderChartRequest): Promise<Types.PostV1ReportsReorderChartResponses> => {
  return await _postV1ReportsReorderChart(baseUrl, request)
}
const _postV1ReportsExpiryDataReport = async (url: string, request: Types.PostV1ReportsExpiryDataReportRequest): Promise<Types.PostV1ReportsExpiryDataReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/expiry-data-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExpiryDataReport: Api['postV1ReportsExpiryDataReport'] = async (request: Types.PostV1ReportsExpiryDataReportRequest): Promise<Types.PostV1ReportsExpiryDataReportResponses> => {
  return await _postV1ReportsExpiryDataReport(baseUrl, request)
}
const _postV1ReportsExpiryDataChart = async (url: string, request: Types.PostV1ReportsExpiryDataChartRequest): Promise<Types.PostV1ReportsExpiryDataChartResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/expiry-data-chart`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExpiryDataChart: Api['postV1ReportsExpiryDataChart'] = async (request: Types.PostV1ReportsExpiryDataChartRequest): Promise<Types.PostV1ReportsExpiryDataChartResponses> => {
  return await _postV1ReportsExpiryDataChart(baseUrl, request)
}
const _postV1ReportsStockMovementReport = async (url: string, request: Types.PostV1ReportsStockMovementReportRequest): Promise<Types.PostV1ReportsStockMovementReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/stock-movement-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsStockMovementReport: Api['postV1ReportsStockMovementReport'] = async (request: Types.PostV1ReportsStockMovementReportRequest): Promise<Types.PostV1ReportsStockMovementReportResponses> => {
  return await _postV1ReportsStockMovementReport(baseUrl, request)
}
const _postV1ReportsStockMovementChart = async (url: string, request: Types.PostV1ReportsStockMovementChartRequest): Promise<Types.PostV1ReportsStockMovementChartResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/stock-movement-chart`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsStockMovementChart: Api['postV1ReportsStockMovementChart'] = async (request: Types.PostV1ReportsStockMovementChartRequest): Promise<Types.PostV1ReportsStockMovementChartResponses> => {
  return await _postV1ReportsStockMovementChart(baseUrl, request)
}
const _getV1Settings = async (url: string, request: Types.GetV1SettingsRequest): Promise<Types.GetV1SettingsResponses> => {
  const queryParameters: (keyof Types.GetV1SettingsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Settings: Api['getV1Settings'] = async (request: Types.GetV1SettingsRequest): Promise<Types.GetV1SettingsResponses> => {
  return await _getV1Settings(baseUrl, request)
}
const _patchV1SettingsId = async (url: string, request: Types.PatchV1SettingsIdRequest): Promise<Types.PatchV1SettingsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SettingsId: Api['patchV1SettingsId'] = async (request: Types.PatchV1SettingsIdRequest): Promise<Types.PatchV1SettingsIdResponses> => {
  return await _patchV1SettingsId(baseUrl, request)
}
const _getV1InventoryValuation = async (url: string, request: Types.GetV1InventoryValuationRequest): Promise<Types.GetV1InventoryValuationResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryValuationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-valuation/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryValuation: Api['getV1InventoryValuation'] = async (request: Types.GetV1InventoryValuationRequest): Promise<Types.GetV1InventoryValuationResponses> => {
  return await _getV1InventoryValuation(baseUrl, request)
}
const _postV1InventoryValuationFifoCost = async (url: string, request: Types.PostV1InventoryValuationFifoCostRequest): Promise<Types.PostV1InventoryValuationFifoCostResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-valuation/fifo-cost`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryValuationFifoCost: Api['postV1InventoryValuationFifoCost'] = async (request: Types.PostV1InventoryValuationFifoCostRequest): Promise<Types.PostV1InventoryValuationFifoCostResponses> => {
  return await _postV1InventoryValuationFifoCost(baseUrl, request)
}
const _postV1InventoryFixedAssetItems = async (url: string, request: Types.PostV1InventoryFixedAssetItemsRequest): Promise<Types.PostV1InventoryFixedAssetItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-fixed-asset-items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InventoryFixedAssetItems: Api['postV1InventoryFixedAssetItems'] = async (request: Types.PostV1InventoryFixedAssetItemsRequest): Promise<Types.PostV1InventoryFixedAssetItemsResponses> => {
  return await _postV1InventoryFixedAssetItems(baseUrl, request)
}
const _getV1InventoryFixedAssetItems = async (url: string, request: Types.GetV1InventoryFixedAssetItemsRequest): Promise<Types.GetV1InventoryFixedAssetItemsResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryFixedAssetItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-fixed-asset-items/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryFixedAssetItems: Api['getV1InventoryFixedAssetItems'] = async (request: Types.GetV1InventoryFixedAssetItemsRequest): Promise<Types.GetV1InventoryFixedAssetItemsResponses> => {
  return await _getV1InventoryFixedAssetItems(baseUrl, request)
}
const _getV1InventoryFixedAssetItemsId = async (url: string, request: Types.GetV1InventoryFixedAssetItemsIdRequest): Promise<Types.GetV1InventoryFixedAssetItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1InventoryFixedAssetItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-fixed-asset-items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InventoryFixedAssetItemsId: Api['getV1InventoryFixedAssetItemsId'] = async (request: Types.GetV1InventoryFixedAssetItemsIdRequest): Promise<Types.GetV1InventoryFixedAssetItemsIdResponses> => {
  return await _getV1InventoryFixedAssetItemsId(baseUrl, request)
}
const _putV1InventoryFixedAssetItemsId = async (url: string, request: Types.PutV1InventoryFixedAssetItemsIdRequest): Promise<Types.PutV1InventoryFixedAssetItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-fixed-asset-items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InventoryFixedAssetItemsId: Api['putV1InventoryFixedAssetItemsId'] = async (request: Types.PutV1InventoryFixedAssetItemsIdRequest): Promise<Types.PutV1InventoryFixedAssetItemsIdResponses> => {
  return await _putV1InventoryFixedAssetItemsId(baseUrl, request)
}
const _deleteV1InventoryFixedAssetItemsId = async (url: string, request: Types.DeleteV1InventoryFixedAssetItemsIdRequest): Promise<Types.DeleteV1InventoryFixedAssetItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/inventory-fixed-asset-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1InventoryFixedAssetItemsId: Api['deleteV1InventoryFixedAssetItemsId'] = async (request: Types.DeleteV1InventoryFixedAssetItemsIdRequest): Promise<Types.DeleteV1InventoryFixedAssetItemsIdResponses> => {
  return await _deleteV1InventoryFixedAssetItemsId(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    postV1InventoryItems: _postV1InventoryItems.bind(url, ...arguments),
    getV1InventoryItems: _getV1InventoryItems.bind(url, ...arguments),
    getV1InventoryItemsId: _getV1InventoryItemsId.bind(url, ...arguments),
    putV1InventoryItemsId: _putV1InventoryItemsId.bind(url, ...arguments),
    deleteV1InventoryItemsId: _deleteV1InventoryItemsId.bind(url, ...arguments),
    postV1InventoryItemsImport: _postV1InventoryItemsImport.bind(url, ...arguments),
    getV1InventoryItemsGenerateExcel: _getV1InventoryItemsGenerateExcel.bind(url, ...arguments),
    postV1InventoryItemsCheck: _postV1InventoryItemsCheck.bind(url, ...arguments),
    postV1NonInventoryItems: _postV1NonInventoryItems.bind(url, ...arguments),
    getV1NonInventoryItems: _getV1NonInventoryItems.bind(url, ...arguments),
    getV1NonInventoryItemsId: _getV1NonInventoryItemsId.bind(url, ...arguments),
    putV1NonInventoryItemsId: _putV1NonInventoryItemsId.bind(url, ...arguments),
    deleteV1NonInventoryItemsId: _deleteV1NonInventoryItemsId.bind(url, ...arguments),
    postV1AssemblyItems: _postV1AssemblyItems.bind(url, ...arguments),
    getV1AssemblyItems: _getV1AssemblyItems.bind(url, ...arguments),
    getV1AssemblyItemsId: _getV1AssemblyItemsId.bind(url, ...arguments),
    putV1AssemblyItemsId: _putV1AssemblyItemsId.bind(url, ...arguments),
    deleteV1AssemblyItemsId: _deleteV1AssemblyItemsId.bind(url, ...arguments),
    postV1AssemblyItemsImport: _postV1AssemblyItemsImport.bind(url, ...arguments),
    postV1Attributes: _postV1Attributes.bind(url, ...arguments),
    getV1Attributes: _getV1Attributes.bind(url, ...arguments),
    getV1AttributesId: _getV1AttributesId.bind(url, ...arguments),
    putV1AttributesId: _putV1AttributesId.bind(url, ...arguments),
    deleteV1AttributesId: _deleteV1AttributesId.bind(url, ...arguments),
    getV1AttributesGenerateExcel: _getV1AttributesGenerateExcel.bind(url, ...arguments),
    postV1DiscountItems: _postV1DiscountItems.bind(url, ...arguments),
    getV1DiscountItems: _getV1DiscountItems.bind(url, ...arguments),
    getV1DiscountItemsId: _getV1DiscountItemsId.bind(url, ...arguments),
    putV1DiscountItemsId: _putV1DiscountItemsId.bind(url, ...arguments),
    deleteV1DiscountItemsId: _deleteV1DiscountItemsId.bind(url, ...arguments),
    getV1DiscountItemsGenerateExcel: _getV1DiscountItemsGenerateExcel.bind(url, ...arguments),
    postV1WarehouseLocation: _postV1WarehouseLocation.bind(url, ...arguments),
    getV1WarehouseLocation: _getV1WarehouseLocation.bind(url, ...arguments),
    getV1WarehouseLocationId: _getV1WarehouseLocationId.bind(url, ...arguments),
    putV1WarehouseLocationId: _putV1WarehouseLocationId.bind(url, ...arguments),
    deleteV1WarehouseLocationId: _deleteV1WarehouseLocationId.bind(url, ...arguments),
    getV1WarehouseLocationGenerateExcel: _getV1WarehouseLocationGenerateExcel.bind(url, ...arguments),
    postV1RoutesRules: _postV1RoutesRules.bind(url, ...arguments),
    getV1RoutesRules: _getV1RoutesRules.bind(url, ...arguments),
    getV1RoutesRulesId: _getV1RoutesRulesId.bind(url, ...arguments),
    putV1RoutesRulesId: _putV1RoutesRulesId.bind(url, ...arguments),
    deleteV1RoutesRulesId: _deleteV1RoutesRulesId.bind(url, ...arguments),
    getV1RoutesRulesOperationTypes: _getV1RoutesRulesOperationTypes.bind(url, ...arguments),
    getV1RoutesRulesWarehouses: _getV1RoutesRulesWarehouses.bind(url, ...arguments),
    postV1Bin: _postV1Bin.bind(url, ...arguments),
    getV1Bin: _getV1Bin.bind(url, ...arguments),
    getV1BinId: _getV1BinId.bind(url, ...arguments),
    putV1BinId: _putV1BinId.bind(url, ...arguments),
    deleteV1BinId: _deleteV1BinId.bind(url, ...arguments),
    getV1BinGenerateExcel: _getV1BinGenerateExcel.bind(url, ...arguments),
    postV1UomTemplates: _postV1UomTemplates.bind(url, ...arguments),
    getV1UomTemplates: _getV1UomTemplates.bind(url, ...arguments),
    getV1Uom: _getV1Uom.bind(url, ...arguments),
    getV1UomTemplatesId: _getV1UomTemplatesId.bind(url, ...arguments),
    putV1UomTemplatesId: _putV1UomTemplatesId.bind(url, ...arguments),
    deleteV1UomTemplatesId: _deleteV1UomTemplatesId.bind(url, ...arguments),
    deleteV1UomUnitsId: _deleteV1UomUnitsId.bind(url, ...arguments),
    getV1UomGenerateExcel: _getV1UomGenerateExcel.bind(url, ...arguments),
    getV1UomUnitsIdCheckConversionFactor: _getV1UomUnitsIdCheckConversionFactor.bind(url, ...arguments),
    postV1CategoryItems: _postV1CategoryItems.bind(url, ...arguments),
    getV1CategoryItems: _getV1CategoryItems.bind(url, ...arguments),
    getV1CategoryItemsId: _getV1CategoryItemsId.bind(url, ...arguments),
    putV1CategoryItemsId: _putV1CategoryItemsId.bind(url, ...arguments),
    deleteV1CategoryItemsId: _deleteV1CategoryItemsId.bind(url, ...arguments),
    getV1CategoryItemsGenerateExcel: _getV1CategoryItemsGenerateExcel.bind(url, ...arguments),
    postV1PackageItems: _postV1PackageItems.bind(url, ...arguments),
    getV1PackageItems: _getV1PackageItems.bind(url, ...arguments),
    getV1PackageItemsId: _getV1PackageItemsId.bind(url, ...arguments),
    putV1PackageItemsId: _putV1PackageItemsId.bind(url, ...arguments),
    deleteV1PackageItemsId: _deleteV1PackageItemsId.bind(url, ...arguments),
    postV1InventoryAdjustment: _postV1InventoryAdjustment.bind(url, ...arguments),
    getV1InventoryAdjustment: _getV1InventoryAdjustment.bind(url, ...arguments),
    getV1InventoryAdjustmentId: _getV1InventoryAdjustmentId.bind(url, ...arguments),
    putV1InventoryAdjustmentId: _putV1InventoryAdjustmentId.bind(url, ...arguments),
    deleteV1InventoryAdjustmentId: _deleteV1InventoryAdjustmentId.bind(url, ...arguments),
    putV1InventoryAdjustmentIdItemItemIdStockStockId: _putV1InventoryAdjustmentIdItemItemIdStockStockId.bind(url, ...arguments),
    getV1InventoryAdjustmentIdDownload: _getV1InventoryAdjustmentIdDownload.bind(url, ...arguments),
    getV1InventoryAdjustmentGenerateExcel: _getV1InventoryAdjustmentGenerateExcel.bind(url, ...arguments),
    postV1ServiceItems: _postV1ServiceItems.bind(url, ...arguments),
    getV1ServiceItems: _getV1ServiceItems.bind(url, ...arguments),
    getV1ServiceItemsId: _getV1ServiceItemsId.bind(url, ...arguments),
    putV1ServiceItemsId: _putV1ServiceItemsId.bind(url, ...arguments),
    deleteV1ServiceItemsId: _deleteV1ServiceItemsId.bind(url, ...arguments),
    getV1Brand: _getV1Brand.bind(url, ...arguments),
    postV1Brand: _postV1Brand.bind(url, ...arguments),
    postV1BinTransfer: _postV1BinTransfer.bind(url, ...arguments),
    getV1BinTransfer: _getV1BinTransfer.bind(url, ...arguments),
    getV1BinTransferId: _getV1BinTransferId.bind(url, ...arguments),
    putV1BinTransferId: _putV1BinTransferId.bind(url, ...arguments),
    deleteV1BinTransferId: _deleteV1BinTransferId.bind(url, ...arguments),
    getV1BinTransferTrackingId: _getV1BinTransferTrackingId.bind(url, ...arguments),
    putV1BinTransferUpdateTrackingId: _putV1BinTransferUpdateTrackingId.bind(url, ...arguments),
    putV1BinTransferUpdateStatusId: _putV1BinTransferUpdateStatusId.bind(url, ...arguments),
    getV1BinTransferGenerateExcel: _getV1BinTransferGenerateExcel.bind(url, ...arguments),
    postV1StockTransfers: _postV1StockTransfers.bind(url, ...arguments),
    getV1StockTransfers: _getV1StockTransfers.bind(url, ...arguments),
    getV1StockTransfersOperationType: _getV1StockTransfersOperationType.bind(url, ...arguments),
    getV1StockTransfersId: _getV1StockTransfersId.bind(url, ...arguments),
    putV1StockTransfersId: _putV1StockTransfersId.bind(url, ...arguments),
    deleteV1StockTransfersId: _deleteV1StockTransfersId.bind(url, ...arguments),
    getV1StockTransfersTrackingId: _getV1StockTransfersTrackingId.bind(url, ...arguments),
    putV1StockTransfersUpdateTrackingId: _putV1StockTransfersUpdateTrackingId.bind(url, ...arguments),
    putV1StockTransfersUpdateTrackingDetailsId: _putV1StockTransfersUpdateTrackingDetailsId.bind(url, ...arguments),
    putV1StockTransfersUpdateStatusId: _putV1StockTransfersUpdateStatusId.bind(url, ...arguments),
    getV1StockTransfersIdDownload: _getV1StockTransfersIdDownload.bind(url, ...arguments),
    getV1StockTransfersGenerateExcel: _getV1StockTransfersGenerateExcel.bind(url, ...arguments),
    postV1StockTransfersIdAddApprover: _postV1StockTransfersIdAddApprover.bind(url, ...arguments),
    putV1StockTransfersIdApprovalStatusApprovalId: _putV1StockTransfersIdApprovalStatusApprovalId.bind(url, ...arguments),
    postV1Stock: _postV1Stock.bind(url, ...arguments),
    getV1Stock: _getV1Stock.bind(url, ...arguments),
    getV1StockId: _getV1StockId.bind(url, ...arguments),
    putV1StockId: _putV1StockId.bind(url, ...arguments),
    deleteV1StockId: _deleteV1StockId.bind(url, ...arguments),
    postV1StockGenerateSerials: _postV1StockGenerateSerials.bind(url, ...arguments),
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    postV1Scrap: _postV1Scrap.bind(url, ...arguments),
    getV1Scrap: _getV1Scrap.bind(url, ...arguments),
    getV1ScrapId: _getV1ScrapId.bind(url, ...arguments),
    putV1ScrapId: _putV1ScrapId.bind(url, ...arguments),
    deleteV1ScrapId: _deleteV1ScrapId.bind(url, ...arguments),
    deleteV1ScrapScrapEntryId: _deleteV1ScrapScrapEntryId.bind(url, ...arguments),
    getV1StockReason: _getV1StockReason.bind(url, ...arguments),
    postV1StockReason: _postV1StockReason.bind(url, ...arguments),
    postV1ReportsInventoryValuationReport: _postV1ReportsInventoryValuationReport.bind(url, ...arguments),
    postV1ReportsInventoryValuationChart: _postV1ReportsInventoryValuationChart.bind(url, ...arguments),
    postV1ReportsStockStatusReport: _postV1ReportsStockStatusReport.bind(url, ...arguments),
    postV1ReportsStockStatusChart: _postV1ReportsStockStatusChart.bind(url, ...arguments),
    postV1ReportsReorderReport: _postV1ReportsReorderReport.bind(url, ...arguments),
    postV1ReportsReorderChart: _postV1ReportsReorderChart.bind(url, ...arguments),
    postV1ReportsExpiryDataReport: _postV1ReportsExpiryDataReport.bind(url, ...arguments),
    postV1ReportsExpiryDataChart: _postV1ReportsExpiryDataChart.bind(url, ...arguments),
    postV1ReportsStockMovementReport: _postV1ReportsStockMovementReport.bind(url, ...arguments),
    postV1ReportsStockMovementChart: _postV1ReportsStockMovementChart.bind(url, ...arguments),
    getV1Settings: _getV1Settings.bind(url, ...arguments),
    patchV1SettingsId: _patchV1SettingsId.bind(url, ...arguments),
    getV1InventoryValuation: _getV1InventoryValuation.bind(url, ...arguments),
    postV1InventoryValuationFifoCost: _postV1InventoryValuationFifoCost.bind(url, ...arguments),
    postV1InventoryFixedAssetItems: _postV1InventoryFixedAssetItems.bind(url, ...arguments),
    getV1InventoryFixedAssetItems: _getV1InventoryFixedAssetItems.bind(url, ...arguments),
    getV1InventoryFixedAssetItemsId: _getV1InventoryFixedAssetItemsId.bind(url, ...arguments),
    putV1InventoryFixedAssetItemsId: _putV1InventoryFixedAssetItemsId.bind(url, ...arguments),
    deleteV1InventoryFixedAssetItemsId: _deleteV1InventoryFixedAssetItemsId.bind(url, ...arguments)
  }
}